export default __webpack_public_path__ + "static/media/click.2318214d.mp3";